(function ($) {
    $(document).ready(function () {
        // FAQ toggle functionality
        $('.ttg-faq__question').on('click', function () {
            const $this = $(this);
            const $answer = $this.next('.ttg-faq__answer');

            // Toggle active class for styling
            $this.toggleClass('active');

            // Update aria attributes for accessibility
            const isExpanded = $this.hasClass('active');
            $this.attr('aria-expanded', isExpanded);

            // Toggle answer with slide animation
            $answer.slideToggle(300);

            // Optional: Close other FAQs when opening one
            // If you want accordion behavior (only one open at a time)
            // Uncomment the lines below
            /*
            if (isExpanded) {
                $('.ttg-faq__question').not($this).removeClass('active');
                $('.ttg-faq__question').not($this).attr('aria-expanded', false);
                $('.ttg-faq__answer').not($answer).slideUp(300);
            }
            */
        });

        // Handle keyboard accessibility
        $('.ttg-faq__question').on('keydown', function (e) {
            // If Enter or Space key is pressed
            if (e.which === 13 || e.which === 32) {
                e.preventDefault();
                $(this).trigger('click');
            }
        });

        // Make sure FAQ questions are keyboard focusable
        $('.ttg-faq__question').attr('tabindex', '0');
    });
})(jQuery);
